import React from 'react'
import NotificationCard from './NotificationCard'
import CoachDashboardProvider, {
  useCoachDashboard,
} from '../CoachDashboardProvider'

const Notifications = () => {
  const { notifications } = useCoachDashboard()
  return (
    <div className="notifications flex flex-col gap-4 rounded-xl border border-silver-400 bg-intoo-blue-medium-50 p-4">
      <div className="subtitle">Notifications</div>

      {notifications.map((notification) => (
        <NotificationCard key={notification.id} notification={notification} />
      ))}

      <a href="/coach/messages" className="self-end text-right underline">
        View all
      </a>
    </div>
  )
}

const Index = (props) => {
  return (
    <CoachDashboardProvider {...props}>
      <Notifications />
    </CoachDashboardProvider>
  )
}

export default Index
